import Angular from "angular";

export default class Screen {

    static onResize(scope, callback) {

        let onResize = function () {
            scope.$apply(()=> {
                callback();
            });
        };

        Angular.element(window).on('resize', onResize);

        scope.$on('$destroy', ()=> {
            Angular.element(window).off('resize', onResize);
        });
    }

    static getOrientation = function () {
        if (window.innerHeight > window.innerWidth) {
            return 'portrait';
        } else {
            return 'landscape';
        }
    };

    static getWidth = function(){
        return window.innerWidth;
    };

    static getWidth = function(){
        return window.innerHeight;
    };

    /**
     * https://v4-alpha.getbootstrap.com/layout/responsive-utilities/
     */
    static hasSize(size) {
        let viewWidth =  window.innerWidth;

        if ('sm-down' == size) {
            return viewWidth < 544 ? false : true;
        }

        if ('sm-down-eq' == size) {
            return viewWidth <= 544 ? false : true;
        }

        if ('md-down' == size) {
            return viewWidth < 768 ? false : true
        }

        if ('md-down-eq' == size) {
            return viewWidth <= 768 ? false : true
        }

        if ('lg-down' == size) {
            return viewWidth < 992 ? false : true
        }

        if ('lg-down-eq' == size) {
            return viewWidth <= 992 ? false : true
        }

        if ('xl-down' == size) {
            return viewWidth < 1200 ? false : true
        }

        if ('xl-down-eq' == size) {
            return viewWidth <= 1200 ? false : true
        }

        if ('sm-up' == size) {
            return viewWidth > 544 ? true : false;
        }

        if ('sm-up-eq' == size) {
            return viewWidth >= 544 ? true : false;
        }

        if ('md-up' == size) {
            return viewWidth > 768 ? true : false;
        }

        if ('md-up-eq' == size) {
            return viewWidth >= 768 ? true : false;
        }

        if ('lg-up' == size) {
            return viewWidth > 992 ? true : false;
        }

        if ('lg-up-eq' == size) {
            return viewWidth >= 992 ? true : false;
        }

        if ('xl-up' == size) {
            return viewWidth > 1200 ? true : false;
        }

        if ('xl-up-eq' == size) {
            return viewWidth >= 1200 ? true : false;
        }

        throw "Unknown option: " + size;
    }
}



// WEBPACK FOOTER //
// ./src/modules/core/util/screen.js